var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoneRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14H6V12H0V14ZM16 0H0V2H16V0ZM13 6H0V8H13.25C14.35 8 15.25 8.9 15.25 10C15.25 11.1 14.35 12 13.25 12H11V10L8 13L11 16V14H13C15.21 14 17 12.21 17 10C17 7.79 15.21 6 13 6Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneRoute);
export default __webpack_public_path__ + "static/media/zone_route.2bbcb2707d8cda1b17c60ba67eba3223.svg";
export { ForwardRef as ReactComponent };